// ADR 16.10.26f §5 — the names of the variants `GUIDES` animates, and nothing
// else. `InstallGuide.tsx` reads this to choose between the lazy stepper and
// the 16.10.26b sentence dialog without importing `guides.ts`, which would
// pull every scene into the boot chunk (§7). `guides.test.ts` keeps it equal
// to `Object.keys(GUIDES)`, which G4 (16.10.26g) grew to every variant but
// `ios_other`.
//
// Must not import the wasm facade: it is in 25.9.26f's boot graph.

import type { GuideVariant } from './variant'

export const GUIDED: ReadonlySet<GuideVariant> = new Set<GuideVariant>([
  'iphone_safari_26',
  'iphone_safari_classic',
  'ipad_safari',
  'ios_chrome',
  'ios_edge',
  'ios_firefox',
  'mac_safari',
])
